import { useState } from "react";
import "@/App.css";
import { StartScreen } from "@/components/StartScreen";
import { GameScreen } from "@/components/GameScreen";
import { Toaster } from "sonner";
import { useSession, useSettings } from "@/game/useSession";

export default function App() {
  const [screen, setScreen] = useState("start"); // 'start' | 'game'
  const [levelId, setLevelId] = useState(1);
  const [practice, setPractice] = useState(false);
  const [player, setPlayer] = useSession(() => setScreen("start"));
  const settings = useSettings();

  const startLevel = (id, isPractice = false) => {
    setLevelId(id);
    setPractice(isPractice);
    setScreen("game");
  };

  const exitToStart = (updatedPlayer) => {
    if (updatedPlayer) setPlayer(updatedPlayer);
    setScreen("start");
  };

  return (
    <div className="min-h-screen bg-[#06060e] text-white flex flex-col items-center justify-center p-2 sm:p-4 font-typewriter select-none overflow-hidden">
      <Toaster theme="dark" position="top-center" />
      {screen === "start" && <StartScreen player={player} setPlayer={setPlayer} onStart={startLevel} settings={settings} />}
      {screen === "game" && (
        <GameScreen
          player={player}
          setPlayer={setPlayer}
          levelId={levelId}
          practice={practice}
          onExit={exitToStart}
          onNext={(id) => startLevel(id)}
          settings={settings}
        />
      )}
    </div>
  );
}
